import React from 'react';

const Situations = () => {
  const situations = [
    'Historisch gewachsene Brief- und Versandkosten ohne klare Übersicht',
    'Einsparziele vorhanden, aber kein strukturiertes Konzept zur Umsetzung',
    'Viele Dienstleister im Einsatz mit geringer Transparenz',
    'Umstellungen werden als operatives Risiko wahrgenommen'
  ];

  return (
    <section className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-6">
            Typische Ausgangssituationen
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed">
            Diese Herausforderungen kennen viele Organisationen im strategischen und operativen Einkauf:
          </p>
          
          <div className="space-y-4">
            {situations.map((situation, index) => (
              <div
                key={index}
                className="flex items-start p-6 bg-slate-50 rounded-lg border border-slate-100 hover:border-slate-300 hover:shadow-lg transition-all duration-300 group backdrop-blur-sm"
              >
                <span className="inline-flex items-center justify-center w-8 h-8 bg-slate-800 text-white rounded-full font-semibold text-sm mr-4 flex-shrink-0 mt-0.5 group-hover:scale-110 group-hover:bg-slate-700 transition-all duration-300 shadow-md">
                  {index + 1}
                </span>
                <p className="text-slate-700 leading-relaxed group-hover:text-slate-900 transition-colors">{situation}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Situations;